module.exports = __webpack_public_path__ + "img/weichatcode.30c1dbcd.png";